import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CapmerRoutingModule } from './capmer-routing.module';
import { CapmerComponent } from './capmer.component';
import { HeaderModule } from '../header/header.module';
import { PipeModule } from '../../pipe/pipe.module';
import { AngularMaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [CapmerComponent],
    imports: [
        CommonModule,
        CapmerRoutingModule,
        AngularMaterialModule,
        HeaderModule,
        PipeModule
    ]
})
export class CapmerModule { }
